var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path9, _rect10, _rect11, _rect12, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 353,
    viewBox: "0 0 630 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.019 217.976L337.501 132.031C337.429 130.838 338.187 128.629 341.8 129.345L511.698 129.345C513.445 128.972 517.598 129.524 520.234 134.717L563.678 195.147C565.016 197.012 568.501 200.742 571.737 200.742L628.131 200.742",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.277 218.2L292.76 132.174C292.846 130.979 292.112 128.768 288.488 129.485L118.455 129.485C116.71 129.112 112.548 129.664 109.851 134.863L65.6933 195.364C64.3334 197.231 60.8036 200.966 57.5649 200.966L1.12513 200.966",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.728 316.902L291.688 324.064C291.761 325.108 291.29 327.197 288.815 327.197L219.571 327.197C218.936 327.197 217.198 325.944 215.323 320.931C214.911 319.829 212.974 315.008 210.027 307.726M1.00859 221.781L20.8776 221.781M136.94 189.775L136.92 193.356L136.962 185.97M136.94 189.775L148.183 189.775M136.94 189.775L125.697 189.775M148.183 189.775L159.427 189.775C161.521 189.775 162.983 192.163 163.452 193.356C173.547 218.082 189.99 258.395 201.671 287.135M148.183 189.775L148.163 193.356L148.205 185.97M125.697 189.775L114.454 189.775C113.027 189.626 109.502 190.133 106.819 193.356L96.3984 205.778M125.697 189.775L125.677 193.356L125.718 185.97M96.3984 205.778L85.9777 218.2C84.7812 219.393 82.0076 221.781 80.4847 221.781L60.6157 221.781M96.3984 205.778L106.749 205.778L86.0475 205.778M40.7466 221.781L40.7203 226.481M40.7466 221.781L60.6157 221.781M40.7466 221.781L20.8776 221.781M60.6157 221.781L60.5893 226.481M20.8776 221.781L20.8512 226.481M210.027 307.726L221.584 307.726M210.027 307.726C208.799 304.691 207.395 301.229 205.853 297.43M205.853 297.43L221.642 297.43M205.853 297.43C204.551 294.22 203.149 290.77 201.671 287.135M201.671 287.135L221.699 287.135",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.471 316.902L336.431 324.064C336.346 325.108 336.794 327.197 339.269 327.197L408.513 327.197C409.148 327.197 410.9 325.944 412.831 320.931C413.256 319.829 415.247 315.008 418.276 307.726M628.259 221.781L608.39 221.781M492.687 189.775L492.667 193.356L492.708 185.97M492.687 189.775L481.444 189.775M492.687 189.775L503.93 189.775M481.444 189.775L470.201 189.775C468.107 189.775 466.618 192.163 466.135 193.356C455.763 218.082 438.867 258.395 426.862 287.135M481.444 189.775L481.424 193.356L481.465 185.97M503.93 189.775L515.174 189.775C516.602 189.626 520.121 190.133 522.768 193.356L533.049 205.778M503.93 189.775L503.91 193.356L503.952 185.97M533.049 205.778L543.33 218.2C544.513 219.393 547.26 221.781 548.783 221.781L568.652 221.781M533.049 205.778L522.698 205.778L543.4 205.778M588.521 221.781L588.495 226.481M588.521 221.781L568.652 221.781M588.521 221.781L608.39 221.781M568.652 221.781L568.626 226.481M608.39 221.781L608.364 226.481M418.276 307.726L406.719 307.726M418.276 307.726C419.538 304.691 420.98 301.229 422.565 297.43M422.565 297.43L406.777 297.43M422.565 297.43C423.904 294.22 425.344 290.77 426.862 287.135M426.862 287.135L406.834 287.135",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.217 201.861L316.212 24.6002C316.216 23.8541 316.701 22.362 318.604 22.362L518.722 22.362C520.943 22.4366 525.388 21.8249 525.405 18.781C525.422 15.7371 525.467 7.66487 525.488 4.00923C525.414 3.11397 525.836 1.32346 528.121 1.32346L619.088 0.990965",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.716 201.861L315.711 24.6002C315.715 23.8541 315.248 22.362 313.348 22.362L113.534 22.362C111.316 22.4366 114.889 21.6447 114.906 18.6008C114.923 15.557 114.969 7.48472 114.989 3.82908C115.073 2.93382 106.667 1.32345 104.386 1.32345L11.1772 1.14331",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.474 337.717L314.429 345.774C314.26 347.714 314.968 351.593 319.156 351.593L492.147 351.593C493.415 351.742 496.862 350.877 500.505 346.221L557.543 274.153C558.581 272.885 561.086 270.348 562.799 270.348L627.76 270.348",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313.484 337.717L313.439 345.774C313.586 347.714 312.835 351.593 308.647 351.593L135.655 351.593C134.386 351.742 130.948 350.877 127.357 346.221L71.1293 274.153C70.1053 272.885 67.629 270.348 65.9157 270.348L0.954684 270.348",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 532.285 22.5857)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 2.60254 22.5859)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.90509,
    height: 14.772,
    transform: "matrix(1 4.36203e-10 -0.00561531 0.999984 291.557 213.528)",
    fill: "url(#paint0_linear_405_1319)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 66.6977,
    transform: "matrix(1 4.36203e-10 0.00561531 -0.999984 290.91 319.587)",
    fill: "url(#paint1_linear_405_1319)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 50.1352,
    transform: "matrix(1 9.28354e-10 -0.00561531 0.999984 313.864 197.414)",
    fill: "url(#paint2_linear_405_1319)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 100.718,
    transform: "matrix(1 4.36203e-10 0.00561531 -0.999984 313.296 337.493)",
    fill: "url(#paint3_linear_405_1319)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.90509,
    height: 14.772,
    transform: "matrix(1 4.36203e-10 -0.00561531 0.999984 336.326 213.528)",
    fill: "url(#paint4_linear_405_1319)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 66.6977,
    transform: "matrix(1 4.36203e-10 0.00561531 -0.999984 335.88 319.588)",
    fill: "url(#paint5_linear_405_1319)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 613.658 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 598.894 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 584.128 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M569.36 193.655C569.362 193.243 569.698 192.909 570.11 192.909L578.319 192.909C579.423 192.909 580.313 193.804 580.307 194.909L580.304 195.559C580.298 196.568 579.476 197.385 578.468 197.385L573.069 197.385C571.009 197.385 569.348 195.715 569.36 193.655Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 16.4111 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 31.1758 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 45.9404 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7009 193.655C60.7032 193.243 60.3711 192.909 59.959 192.909L51.7508 192.909C50.6462 192.909 49.7458 193.804 49.7396 194.909L49.7359 195.559C49.7303 196.568 50.5431 197.385 51.5514 197.385L56.9496 197.385C59.0098 197.385 60.6893 195.715 60.7009 193.655Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_405_1319",
    x1: 0.952545,
    y1: 0,
    x2: 0.952545,
    y2: 14.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_405_1319",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 66.6977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_405_1319",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_405_1319",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 100.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_405_1319",
    x1: 0.952545,
    y1: 0,
    x2: 0.952545,
    y2: 14.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_405_1319",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 66.6977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame1);
export default __webpack_public_path__ + "static/media/card1-frame1.ca36e762a52745452a74db115df631ac.svg";
export { ForwardRef as ReactComponent };